module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-fog-02bdd464.svg";